/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { TourFilter } from '@construction-sites/models/tour-filter';
import { Action } from '@ngrx/store';
import { ConstructionSite, Tour } from '@shared/models';

export const LOAD_CONSTRUCTION_SITES = '[Construction Sites] Load';
export const LOAD_CONSTRUCTION_SITES_FAILURE = '[Construction Sites] Load failure';
export const LOAD_CONSTRUCTION_SITES_SUCCESS = '[Construction Sites] Load success';
export const SET_TOUR_FILTER = '[Construction Sites] Set tour filter';
export const LOAD_TOURS = '[Construction Sites] Load tours';
export const LOAD_TOURS_FAILURE = '[Construction Sites] Load tours failure';
export const LOAD_TOURS_SUCCESS = '[Construction Sites] Load tours success';
export const SET_CURRENT_CONSTRUCTION_SITE = '[Construction Sites] Set current';

export class LoadConstructionSites implements Action {
  readonly type = LOAD_CONSTRUCTION_SITES;
  constructor(public customerId: number, public activeOnly = true) { }
}

export class LoadConstructionSitesFailure implements Action {
  readonly type = LOAD_CONSTRUCTION_SITES_FAILURE;
}

export class LoadConstructionSitesSuccess implements Action {
  readonly type = LOAD_CONSTRUCTION_SITES_SUCCESS;
  constructor(public constructionSites: ConstructionSite[]) { }
}

export class SetTourFilter implements Action {
  readonly type = SET_TOUR_FILTER;
  constructor(public tourFilter: Partial<TourFilter>) { }
}

export class LoadTours implements Action {
  readonly type = LOAD_TOURS;
  constructor() { }
}

export class LoadToursFailure implements Action {
  readonly type = LOAD_TOURS_FAILURE;
}

export class LoadToursSuccess implements Action {
  readonly type = LOAD_TOURS_SUCCESS;
  constructor(public tours: Tour[]) { }
}

export class SetCurrentConstructionSite implements Action {
  readonly type = SET_CURRENT_CONSTRUCTION_SITE;
  constructor(public constructionSite: ConstructionSite) { }
}

export type ConstructionSiteActions = LoadConstructionSites | LoadConstructionSitesFailure | LoadConstructionSitesSuccess | LoadTours |
  LoadToursFailure | LoadToursSuccess | SetTourFilter | SetCurrentConstructionSite;
